import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface VideoCompareColumnProps {
  title: ReactNode;
  titleClassName?: string;
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}

export const VideoCompareColumn = ({ title, titleClassName, action, className, children }: VideoCompareColumnProps) => (
  <div className={twMerge("flex-1 min-w-0 flex flex-col items-center border-r border-kds-border", className)}>
    <div className="flex items-center justify-between p-[16px] w-full shrink-0">
      <span className={twMerge("font-bold text-[16px] leading-[24px] text-kds-fg whitespace-nowrap", titleClassName)}>
        {title}
      </span>
      {action}
    </div>
    <div className="flex-1 min-h-0 w-full flex items-center justify-center px-[16px] pb-[16px]">{children}</div>
  </div>
);
